<template>
  <div>
    <div :class="{'left-panel centered':true, 'no-scroll':respond.show}">
      <div class="heading">
        <span class="cons-name">CREATE PROFILE</span>
      </div>

      <div class="body card">
        <div class="back-section">
          <a href="/#/corporate"><i class="fas fa-chevron-left"></i>Back</a>
        </div>

        <div class="row">
          <div class="medium-12 column">
            <div class="logo-box">
              <span class="recommended">Recommended size: 200 x 200 px</span>
              <div :class="{'img-hover-box':true, 'loading':upload.loading}">
                <img :src="corporateInfo.logo" v-if="corporateInfo.logo" />
                <i class="fas fa-user-circle" v-else></i>
                <div class="button cta small" @click="triggerUpload">CHANGE LOGO</div>
                <transition name="slide-up">
                  <i class="fa fa-spinner fa-spin fa-2x" v-show="upload.loading"></i>
                </transition>
              </div>
              <span class="error-msg">{{ upload.message }}</span>
              <input type="file" ref="uploadInput" v-show="false" @change="uploadFile" />
            </div>
          </div>

          <div class="medium-6 column padding-R-m">
            <div class="details-box row">
              <div class="medium-12 column margin-B-s">
                <div class="data-field">
                  <div class="label">Username</div>
                  <input type="text" class="input" :disabled="loading"
                    v-model="corporateInfo.username" name="username" />
                  <span class="error-msg">{{ validation.username }}</span>
                </div>
              </div>
              <div class="medium-12 column">
                <div class="data-field">
                  <div class="label">Password</div>
                  <input type="password" class="input" :disabled="loading"
                    v-model="corporateInfo.password" />
                  <span class="error-msg">{{ validation.password }}</span>
                </div>
              </div>
              <div class="medium-12 column margin-B-m">
                <div class="data-field">
                  <div class="label">Repeat Password</div>
                  <input type="password" class="input" :disabled="loading"
                    v-model="repeatPassword" />
                  <span class="error-msg">{{ validation.repeatPassword }}</span>
                </div>
              </div>
              <div class="medium-12 column margin-B-s">
                <div class="data-field">
                  <div class="label">Corporate Name</div>
                  <input type="text" class="input" :disabled="loading"
                    v-model="corporateInfo.name" />
                  <span class="error-msg">{{ validation.name }}</span>
                </div>
              </div>

              <div class="medium-6 column margin-B-s">
                <div class="data-field">
                  <div class="label">Email</div>
                  <input type="text" class="input" :disabled="loading"
                    v-model="corporateInfo.email" />
                  <span class="error-msg">{{ validation.email }}</span>
                </div>
              </div>
              <div class="medium-6 column margin-B-s">
                <div class="data-field">
                  <div class="label">Corporate Color</div>
                  <input type="text" class="input" :disabled="loading"
                    @click="showEmailColor = true" v-model="corporateInfo.color"/>
                  <span class="error-msg">{{ validation.color }}</span>
                  <div class="palette" :style="{'backgroundColor': '#' + corporateInfo.color}"
                    @click="showEmailColor = true"></div>
                  <transition name="slide-down">
                    <div class="color-picker right" v-show="showEmailColor">
                      <chrome-picker v-model="emailColors" @input="updateColor"></chrome-picker>
                    </div>
                  </transition>
                </div>
              </div>

              <div class="medium-12 column margin-B-s">
                <div class="data-field">
                  <div class="label">Mobile</div>
                  <div class="input-group">
                    <div class="country-select input-group-label" @click="selectCountry">
                      <span class="country-code">(+{{callingCode}}) </span>
                      <i class="fa fa-caret-down"></i>
                    </div>
                    <input type="text" class="input" :disabled="loading"
                      v-model="corporateInfo.mobile" />
                  </div>
                  <span class="error-msg">{{ validation.mobile }}</span>
                </div>
              </div>

              <div class="medium-12 column margin-B-m">
                <div class="data-field">
                  <div class="label">Website</div>
                  <input type="text" class="input" :disabled="loading"
                    v-model="corporateInfo.website" />
                  <span class="error-msg">{{ validation.website }}</span>
                </div>
              </div>
            </div>
          </div>

          <div class="medium-6 column padding-L-m">

            <div class="billing-box medium-12 column">
              <div class="billing-label">Billing Info</div>

              <div class="medium-12 column">
                <div class="data-field">
                  <div class="label">Address1</div>
                  <input type="text" class="input" :disabled="loading"
                    v-model="corporateInfo.billingAddress1" />
                  <span class="error-msg">{{ validation.billingAddress1 }}</span>
                </div>
              </div>

              <div class="medium-12 column margin-B-s">
                <div class="data-field">
                  <div class="label">Address2</div>
                  <input type="text" class="input" :disabled="loading"
                    v-model="corporateInfo.billingAddress2" />
                </div>
              </div>

              <div class="medium-12 column margin-B-s">
                <div class="data-field">
                  <div class="label">City</div>
                  <input type="text" class="input" :disabled="loading"
                    v-model="corporateInfo.billingCity" />
                  <span class="error-msg">{{ validation.billingCity }}</span>
                </div>
              </div>

              <div class="medium-6 columns margin-B-s">
                <div class="data-field">
                  <div class="label">State</div>
                  <select v-model="corporateInfo.billingState" :disabled="loading"
                    :class="{'has-error':false}">
                    <option value=""></option>
                    <option value="NonUS">Non US</option>
                    <option v-for="state in states" :value="state.label" :key="state.value">{{state.label}}</option>
                  </select>
                  <span class="error-msg">{{ validation.billingState }}</span>
                </div>
              </div>

              <div class="medium-6 column margin-B-s">
                <div class="data-field">
                  <div class="label">Zip</div>
                  <input type="text" class="input" :disabled="loading"
                    v-model="corporateInfo.billingZip" />
                  <span class="error-msg">{{ validation.billingZip }}</span>
                </div>
              </div>

              <div class="medium-12 column margin-B-s" v-show="corporateInfo.billingState === 'NonUS'">
                <div class="data-field">
                  <div class="label">Country</div>
                  <select v-model="corporateInfo.biilingCountry" :disabled="loading"
                    :class="{'input':true, 'has-error':false}">
                    <option v-for="(country, index) in countries.all"
                      :key="index" :value="country.alpha2">{{country.name}}</option>
                  </select>
                  <span class="error-msg">{{ validation.biilingCountry }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="medium-12 column margin-T-l">
            <div class="button cta success block" @click="submit">
              <span v-if="loading">
                <i class="fa fa-spinner fa-spin"></i>
                Loading ...
              </span>
              <span>CREATE ACCOUNT</span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <transition name="expand">
      <div class="respond-box" v-if="respond.show">
        <div class="vertical-center">
          <div class="card">
            <div class="success">
              <i class="fas fa-check-circle" v-if="respond.success"></i>
              <i class="fas fa-times-circle" v-else></i>
              <div class="label">{{ respond.label }}</div>
              <div class="message" v-if="!!respond.message" v-html="respond.message"></div>
            </div>
            <div class="button cta block small margin-T-l" @click="closeResponModal">Close</div>
          </div>
        </div>
      </div>
    </transition>

  </div>
</template>

<script>
/* global CONFIG */
import { Chrome } from 'vue-color'
import US from 'us'
import ApiCorporateProfile from '@/modules/api/corporate/profile'
const countryData = require('@/data/countries')


export default {
  name: 'create-profile',
  components: { 'chrome-picker': Chrome },
  data () {
    return {
      statusLoading: false,
      upload: {
        loading: false,
        message: ''
      },
      repeatPassword: '',
      showEmailColor: false,
      emailColors: '',
      colorDelay: '',
      countries: require('country-data').countries,
      validation: {
        logo: '',
        username: '',
        password: '',
        repeatPassword: '',
        name: '',
        email: '',
        color: '',
        mobile: '',
        website: '',
        cardOwner: '',
        creditCard: '',
        cardExpiration: '',
        cardCVV: '',
        billingAddress1: '',
        billingCity: '',
        billingState: '',
        biilingCountry: ''
      },
      respond: {
        show: false,
        success: false,
        label: '',
        message: '',
        id: ''
      }
    }
  },
  computed: {
    _corporateId () { return this.$route.params.id },
    corporateInfo () { return this.$store.state.corporate.profile.info },
    loading () { return this.$store.state.corporate.profile.loading },
    states () {
      let states = []
      for (let key in US.states) {
        if (US.states.hasOwnProperty(key)) {
          states.push({
            value: key,
            label: US.states[key].name
          })
        }
      }
      return states
    },
    callingCode () {
      return this.$store.state.countryCode.callingCode
    },
  },
  methods: {
    selectCountry() {
      this.$store.commit('countryCode/setCountryModal', true)
    },
    getCorporateData () {
      let self = this
      self.$store.commit('corporate/resetProfileInfo')
    },
    triggerUpload () {
      if (this.loading) { return }
      this.$refs.uploadInput.click()
    },
    uploadFile (e) {
      if (!e.target.files.length) { return }

      let self = this
      let file = e.target.files[0]
      let fd = new FormData()
      fd.append('pic', file)

      self.upload.loading = true
      self.upload.message = ''

      self.$http.post(CONFIG.mediaHost + '/api/upload', fd, {
        header: {'Content-Type': 'multipart/form-data'}
      }).then(function (res) {
        self.upload.loading = false
        if (!res.body.success) {
          self.upload.message = 'Upload fail. Please try again.'
          // self.upload[self.upload.target].success = false
          return
        }

        self.corporateInfo.logo = res.body.data.url

      }, function (res) {
        self.upload.loading = false
        self.upload.message = res
        console.log('error', res)
      })
    },
    selectColor () {
      this.$store.commit('corporate/setProfileColor', this.emailColors.hex.substring(1, this.emailColors.hex.length))
      this.showEmailColor = false
    },
    updateColor (value) {
      let self = this
      if (self.colorDelay) {
        clearTimeout(self.colorDelay)
      }

      self.$store.state.corporate.profile.info.color = value.hex.substring(1, value.hex.length)
      self.colorDelay = setTimeout(function () {
        self.showEmailColor = false
      }, 1200)
    },
    isNumber (evt) {
      let charCode = (evt.which) ? evt.which : evt.keyCode;
      if ((charCode > 31 && (charCode < 48 || charCode > 57))) {
        evt.preventDefault()
        return
      }
      return true;
    },
    submit () {
      let self = this
      if (self.loading || !self.validate() || self.upload.loading) { return }

      self.$store.commit('corporate/setProfileLoading', true)

      ApiCorporateProfile.create(self, res => {
        self.$store.commit('corporate/setProfileLoading', false)
        if (!res.error) {
          self.respond = {
            show: true,
            success: true,
            label: 'Successfully updated profile.',
            message: ''
          }
          window.location = '/#/corporate/' + res.id
        } else {
          self.respond = {
            show: true,
            success: false,
            label: 'Oops! Something went wrong.',
            message: res.error.message,
            id: ''
          }
        }
      })
    },
    validate () {
      let noError = true

      if (this.upload.message !== '') {
        noError = false
      }

      for (let field in this.validation) {
        this.validation[field] = ''
        if (this.corporateInfo[field] === '') {
          this.validation[field] = 'This field cannot be empty.'
          noError = false
        }
      }

      if (this.corporateInfo.username.indexOf(' ') > -1) {
        this.validation.username = 'Space is not allowed'
        noError = false
      }

      if (this.repeatPassword === '') {
        this.validation.repeatPassword = 'This field cannot be empty.'
        noError = false
      }

      if (this.repeatPassword !== '' && this.corporateInfo.password !== '' &&
        this.repeatPassword !== this.corporateInfo.password
      ) {
        this.validation.repeatPassword = 'Password and Repeat password doesn\'t match.'
        noError = false
      }

      return noError
    },
    clearValidation () {
      this.validation = {
        logo: '',
        username: '',
        password: '',
        repeatPassword: '',
        name: '',
        email: '',
        color: '',
        mobile: '',
        website: '',
        billingAddress1: '',
        billingCity: '',
        billingState: '',
        biilingCountry: ''
      }
    },
    closeResponModal () {
      this.respond.show = false
      if (this.respond.id) {
        window.location = '/#/corporate/' + this.respond.id
      }
    }
  },
  watch: {
    _corporateId (val) {
      this.clearValidation()
      this.repeatPassword = ''
      this.$store.commit('corporate/resetProfileInfo')
    },
    'corporateInfo.billingState': function (val) {
      if (val && val !== 'NonUS') {
        this.corporateInfo.biilingCountry = 'US'
      }
    }
  },
  mounted () {
    this.clearValidation()
    this.$store.commit('corporate/resetProfileInfo')
    this.$store.commit('countryCode/reset')
  }
}

</script>

<style lang="scss" scoped>
.left-panel{
  position: fixed;
  z-index: 2;
  left: 0;
  top: 0;
  width: 500px;
  height: 100%;
  box-shadow: 2px 0 4px rgba(0,0,0,0.2);
  background-color: #F4F8F9;
  overflow-y: auto;

  &.no-scroll{ overflow: hidden; }
  .heading{ padding-left: 50px; }
  &.centered{
    width: 100%;

    .heading{
      background:#fff;
      border-bottom: 1px solid #ddd;
      margin-bottom: 20px;
    }
  }
}

.heading{
  height: 50px;
  font-size: 18px;
  font-weight: 600;
  color: #333;
  padding: 10px 0;

  & .cons-name{
    padding: 0 5px 0 15px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 200px;
    display: inline-block;
  }
}

.body{
  padding: 20px;
  background: #fafafa;
  border-top: 1px solid #ccc;

  &.card{
    width: 900px;
    margin: 0 auto;
  }
}

.back-section{
  font-size: 15px;
  margin-bottom: 5px;

  a{
    cursor: pointer;
    text-decoration: none;
  }
  i{ margin-right: 7px; }
}
.logo-box{
  text-align: center;
  border-bottom: 1px solid #ddd;
  padding: 0 20px 20px;

  .fa-user-circle{
    font-size: 140px;
    margin-top: 30px;
    color: #f2ad6d;
  }
  img{
    max-width: 200px;
    max-height: 200px;
    cursor: pointer;
    transition: .2s ease all;
  }
  .img-hover-box{
    position: relative;
    display: inline-block;
    border: 3px dashed #ddd;
    width: 206px;
    height: 206px;
    overflow: hidden;
    background: #fff;

    .button{
      position: absolute;
      top: 60%;
      left: 50%;
      margin-top: -20px;
      margin-left: -63px;
      opacity: 0;
    }
    &:hover{
      img{ opacity: .6; }
      .button{
        opacity: 1;
        top: 50%;
      }
    }
    .fa-spinner{
      position: absolute;
      top: 50%;
      left: 50%;
      z-index: 3;
      margin-top:-16px;
      margin-left:-16px;
    }
    &.loading{
      img{ opacity: .6; }
      &:hover .button{ display: none; }
    }
  }
  .recommended{
    display: block;
    font-size: 14px;
    margin-bottom: 5px;
    color: #666;
    font-weight: 600;
  }
  .error-msg{
    display: block;
    font-weight: 100;
    margin-top: 2px;
    color: #f20d0d;
    font-size: 12px;
    font-style: italic;
  }
}

.details-box{ padding: 20px 0; }

.data-field{
  padding: 5px;
  position: relative;

  .label{
    color: #888;
    font-weight: 600;
    font-size: 11px;
    text-transform: uppercase;
    line-height: 130%;

    &.has-error{ color: #f20d0d; }
  }
  .input{
    margin: 1px 0 0;
    padding: 5px;
    font-size: 14px;
    color: #333;
    line-height: inherit;
    transition: all .35s ease;

    &.has-error{ border-color: #f20d0d; }
    &:disabled{ background: #eee; }
  }
  .error-msg{
    font-size: 11px;
    line-height: 1.6;
    color: #f20d0d;
    font-style: italic;
    display: block;
  }
  select{
    border: 1px solid #ddd;
    padding: 5px;
    color: #333;
    height: 35px;
    position: relative;
    font-size:14px;
    outline: none;
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    background-image: url('/assets/img/dropdown-arrow.png');
    background-repeat: no-repeat;
    background-position: right 50%;
    transition: all .35s ease;

    &.has-error{ border-color: #f20d0d; }
    &:disabled{ background-color: #eee; }
  }
}

.billing-box{
  padding: 15px;
  background: #f2f2f2;
  border: 1px solid #dedede;
  border-radius: 4px;
  margin-top: 30px;

  .billing-label{
    font-size: 21px;
    font-weight: 600;
    padding-bottom: 5px;
    color: #333;
    text-align: center;
  }
  .label{ color: #122a43; }
  .error-msg{ color: #f20d0d; }
}

.palette{
  position: absolute;
  top: 27px;
  right: 13px;
  background-color: #fafafa;
  width: 20px;
  height: 20px;
  border-radius: 10px;
  cursor: pointer;
}

.color-picker{
  position: absolute;
  top: 100%;
  z-index: 3;
  transform-origin: top center;

  &.right{ right: 0; }
  &.left{ left: 0; }
}


.respond-box, .confirm-card{
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 4;
  background: rgba(0,0,0, .5);
  display: table;

  .vertical-center{
    display: table-cell;
    vertical-align: middle;
  }
  .card{
    width: 80%;
    max-width: 500px;
    margin: 0 auto;
    padding: 15px;
    text-align: center;
  }
  .fa-check-circle, .fa-times-circle{
    font-size: 100px;
    color: #26d97a;
    margin-bottom: 5px;
  }
  .fa-times-circle{ color: #F20D0D; }
  .label{
    font-weight: 600;
    color: #505050;
  }
  .message{
    font-size: 14px;
    color: #777;
    margin: 10px 0;
  }
}

.input-group {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  width: 100%;
  -webkit-box-align: stretch;
  -webkit-align-items: stretch;
  -ms-flex-align: stretch;
  align-items: stretch;
  position: relative;
  margin-bottom: 0;

 .input-group-label {
  padding: 0 10px;
  border: 1px solid #cacaca;
  background: #f4f8f9;
  color: #0a0a0a;
  text-align: center;
  white-space: nowrap;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-flex: 0;
  -webkit-flex: 0 0 auto;
  -ms-flex: 0 0 auto;
  flex: 0 0 auto;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
 }

 .mobile-input {
  padding-left: 25px;
  border-radius: 1px;
  border-left: 0;
 }

  &.small {
    .mobile-input {
      padding-left: 35px;
    }
  }
  &.medium {
    .mobile-input {
      padding-left: 45px;
    }
  }
  &.large {
    .mobile-input {
      padding-left: 55px;
    }
  }
  &.xl {
    .mobile-input {
      padding-left: 65px;
    }
  }

}

/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type=number] {
  -moz-appearance:textfield;
}

.country-select {
  margin-top: 1px;
  cursor: pointer;
  color: #333;
  transition: 0.3s;
}

.country-select:hover {
  background-color: #e6e6e6;
}

.country-code {
  margin-right: 3px;
  font-weight: 100;
  font-size: 15px;
}

.margin-B-s{ margin-bottom: 5px; }
.margin-B-m{ margin-bottom: 10px; }
.margin-T-l{ margin-top: 15px; }
.padding-R-m{ padding-right: 10px; }
.padding-L-m{ padding-left: 10px; }

.slide-up-enter-active, .slide-up-leave-active { transition: all .6s ease; }
.slide-up-enter, .slide-up-leave-to {
  transform: translateY(30px);
  opacity: 0;
}

.slide-down-enter-active, .slide-down-leave-active { transition: all .3s ease; }
.slide-down-enter, .slide-down-leave-to {
  transform: rotateX(-90deg);
  opacity: 0;
}

.expand-enter-active, .expand-leave-active { transition: all .1s ease; }
.expand-enter, .expand-leave-to {
  transform: scale(.95);
  opacity: 0;
}

@media only screen and (max-width: 430px) {
  .body.card {
    width: 100%;
    padding-bottom: 50px;
  }

  .billing-box {
    margin-top: 0;
    margin-bottom: 20px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Corporate/CreateProfile.vue